import { Bot, UserPlus, StickyNote } from 'lucide-react'

interface BotTakeoverBarProps {
  isEscalating: boolean
  onTakeover: () => void
  onAddNote?: () => void
  salesStageLabel?: string
}

export function BotTakeoverBar({
  isEscalating,
  onTakeover,
  onAddNote,
  salesStageLabel,
}: BotTakeoverBarProps) {
  return (
    <div className="border-t border-blue-100 bg-gradient-to-r from-blue-50 via-sky-50 to-blue-50 px-4 py-3.5 lg:px-6">
      <div className="flex flex-wrap items-center justify-between gap-3 lg:mx-auto lg:max-w-5xl">
        <div className="flex items-center gap-3 min-w-0">
          <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-xl bg-blue-100 text-blue-700 shadow-2xs">
            <Bot className="h-5 w-5" />
          </div>
          <div className="min-w-0">
            <div className="flex items-center gap-2">
              <p className="text-xs font-bold text-blue-950 sm:text-sm">
                Bot de ventas activo
              </p>
              {salesStageLabel && (
                <span className="rounded-full bg-blue-100/80 px-2 py-0.5 text-[10px] font-semibold text-blue-800">
                  Etapa: {salesStageLabel}
                </span>
              )}
            </div>
            <p className="text-[11px] sm:text-xs text-blue-800/80">
              El asistente IA está atendiendo al cliente. Puedes tomar el control para responder directamente.
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2 flex-shrink-0">
          {onAddNote && (
            <button
              type="button"
              onClick={onAddNote}
              className="inline-flex items-center gap-1.5 rounded-lg border border-blue-200 bg-white px-3 py-1.5 text-xs font-medium text-blue-900 shadow-2xs transition-colors hover:bg-blue-50 active:scale-[0.98]"
            >
              <StickyNote className="h-3.5 w-3.5 text-blue-600" />
              <span>Dejar nota</span>
            </button>
          )}

          <button
            type="button"
            onClick={onTakeover}
            disabled={isEscalating}
            className="inline-flex items-center gap-1.5 rounded-lg bg-purple-600 px-3.5 py-1.5 text-xs font-bold text-white shadow-xs shadow-purple-600/20 transition-all hover:bg-purple-700 disabled:opacity-50 active:scale-[0.98]"
          >
            <UserPlus className="h-3.5 w-3.5" />
            <span>{isEscalating ? 'Tomando control...' : 'Tomar control'}</span>
          </button>
        </div>
      </div>
    </div>
  )
}
